import type { DailySalesReport } from '../../../../api/daily-sales';
import { easternTime, longDate, shortDate } from '../daily-sales-format';

export function DailySalesFreshness({ report }: { report: DailySalesReport }) {
  const latest = (source: string, at: string | null) =>
    at ? `latest ${source} sale ${easternTime(at)}` : `no ${source} sales in this window`;

  return (
    <div className="nb-ds-meta">
      {shortDate(report.from)} – {longDate(report.to)} · Built {easternTime(report.generatedAt)}
      {report.to === report.today && (
        <>
          <br />
          {latest('FareHarbor', report.fareharborLatestSale)} ·{' '}
          {latest('Nebari', report.nebariLatestSale)}
        </>
      )}
    </div>
  );
}
